module.exports = __webpack_public_path__ + "img/backimg.29304acf.png";